import { useContext, useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { SDKContext } from "src/context/SDKContext"
import { nativeMobileSafeAreaAtom } from "src/recoil/atoms/nativeMobileSafeArea"

type Props = {
  children: React.ReactNode
  background?: string
  bottomArea?: boolean
  topArea?: boolean
}

export const SafeArea = ({
  children,
  background,
  bottomArea = true,
  topArea = true,
  ...rest
}: Props & React.CSSProperties) => {
  const nativeMobileSafeArea = useRecoilValue(nativeMobileSafeAreaAtom)

  return (
    <div
      style={{
        background,
        height: "100%",
        width: "100%",
        paddingTop: topArea && nativeMobileSafeArea.enableTopSafeArea ? nativeMobileSafeArea.top : 0,
        paddingBottom: bottomArea && nativeMobileSafeArea.enableBottomSafeArea ? nativeMobileSafeArea.bottom : 0,
        overflow: "hidden",
        ...rest
      }}
    >
      {children}
    </div>
  )
}
